import styled from '@emotion/styled'

export const StyleTableCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
`

export const StyleTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`
export const StyleTableHead = styled.thead``

export const StyleTableRow = styled.tr<any>`
  cursor: pointer;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  &:last-child {
    border-bottom: none;
  }
`
export const StyleTableHeader = styled.th<any>`
  font-size: 14px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 500;
  text-align: left;
  height: 35px;
  padding-left: 15px;
  padding-right: 10px;
  background: ${(props) => props.theme.colors.secondary50};
`
export const StyleTableBody = styled.tbody<any>``
export const StyleTableBodyText = styled.td<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
  border-bottom: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 10px;
  text-align: justify;
`

export const StyleNotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StyleFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
  padding-top: 20px;
  margin-bottom: 20px;
`

export const StyleSearchWrapper = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  color: ${(props: any) => props.theme.colors.inputBorder};
  padding: 0px 16px;
  width: 30%;
  height: ${(props: any) => props?.height || '40'}px;
  align-items: center;

  @media (max-width: 768px) {
    width: 200px;
    padding: 8px 12px;
  }

  @media (max-width: 480px) {
    padding: 6px 10px;
    height: 36px;
    width: 100%;
  }
`
export const StyleSearchInput = styled.input<any>`
  font-size: 14px;
  width: 100%;
  border: none;
  text-indent: 7px;
  color: ${(props) => props.theme.colors.text};
  outline: none;
  ::placeholder {
    color: ${(props) => props.theme.colors.inputBorder};
  }
`

export const StyleTableActionWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`

export const StyleActionItem = styled.div<any>``
